export default __webpack_public_path__ + "static/media/hourglass_empty.364a16cd.svg";